import { mapGetters } from 'vuex';
import personTypes from '../views/games/memory/personType';

export default {
  data() {
    return {
      entity: {
        title: '',
        quotes: [],
        memory_image: null,
        ref_id: 0,
        is_person: false,
      },
      source: {
        title: '',
        quotes: [],
        memory_image: null,
        ref_id: 0,
        is_person: false,
      },
      imageSelected: false,
      imageOnLoadHandlerSet: false,
      imageLoaded: false,
      personTypes,
    };
  },

  computed: {
    ...mapGetters({
      images: 'memoryGame/imageList',
    }),
  },

  methods: {
    addQuote() {
      this.entity.quotes.push({
        text: '',
      });
      this.entity = {
        ...this.entity,
      };
      this.entity.quotes = [
        ...this.entity.quotes,
      ];
    },
    onDeleteQuote(index) {
      this.entity.quotes.splice(index, 1);
      this.entity = {
        ...this.entity,
      };
      this.entity.quotes = [
        ...this.entity.quotes,
      ];
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/MemoryGameMixin.js